'use client';

import React from 'react';

import Button from '@/components/V2/Button';

interface FindPetProProps {
  onSelection?: (knowsPetPro: boolean) => void;
}

const FindPetPro: React.FC<FindPetProProps> = ({ onSelection = () => {} }) => {
  return (
    <div className="v2-max-w-[640px] v2-mx-auto v2-mt-[165px] md:v2-mt-0">
      <h2 className="v2-mb-6 v2-font-sweet-sans-pro v2-font-normal v2-text-[#101828] v2-text-4xl md:v2-text-4xl">
        Find a petPro
      </h2>
      <div className="v2-py-6 v2-px-4 md:v2-py-8 md:v2-px-8 v2-shadow-xl v2-rounded-xl">
        <p className="v2-font-sweet-sans-pro v2-font-normal v2-text-[#101828] v2-mb-8 v2-text-2xl md:v2-text-4xl">
          Do you know a pet pro?
        </p>
        <div className="v2-flex v2-flex-col md:v2-flex-row v2-items-center v2-gap-4">
          <Button
            btnSize="md"
            scheme="primary"
            variant="filled"
            type="button"
            className="v2-w-full v2-font-sweet-sans-pro-medium v2-font-medium v2-h-[44px] v2-flex v2-items-center v2-justify-center"
            onClick={() => onSelection(true)}
          >
            Yes, I know my pet pro
          </Button>
          <Button
            btnSize="md"
            scheme="primary"
            variant="outlined"
            type="button"
            className="v2-w-full v2-font-sweet-sans-pro-medium v2-font-medium v2-text-primary-700 v2-h-[44px] v2-flex v2-items-center v2-justify-center"
            onClick={() => onSelection(false)}
          >
            No, I don&apos;t know a pet pro
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FindPetPro;
